import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

/**
 * // 判断两个数组是否有相同项
 * @param {*} list1
 * @param {*} list2
 * @returns
 */
export function isSomeListInfo(list1, list2) {
  if (list1.indexOf('allow') !== -1) {
    return true
  }
  for (let i = 0; i < list1.length; i++) {
    if (list2.indexOf(list1[i]) !== -1) {
      return true
    }
  }
  return false
}

export function filterRoute(list, jurisdiction) {
  const _list = []
  list.forEach((el) => {
    let _flag = false
    // 浅拷贝 防止asyncRoutes被影响
    const _obj = { ...el }
    if (el.children) {
      // 浅拷贝 防止asyncRoutes被影响
      _obj.children = [...el.children]
    }
    if (el.type && el.type.includes('allow')) {
      _flag = true
    }
    // ?
    if (el.hidden) {
      _obj.hidden = el.hidden
    }
    if (el.children && el.children.length > 0) {
      const _children = []
      el.children.forEach((it) => {
        if (isSomeListInfo(it.type, jurisdiction)) {
          _children.push(it)
          _flag = true
        }
      })
      // 如果上面不进行浅拷贝，这里赋值会把asyncRoutes的children数组也设置为空数组
      // 进而导致退出登录后，重新登录，部分路由会消失，只能刷新浏览器才能更新路由
      _obj.children = _children
    }
    if (_flag) {
      _list.push(_obj)
    }
  })
  return [..._list]
}
